// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("channels")
require("jquery.easing")
require("jquery-hoverintent")
require("select2")
require("flatpickr")

// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

const sorter = function(results) {
  let query = $('.select2-search__field').val().toLowerCase();
  return results.sort(function(a, b) {
    return a.text.toLowerCase().indexOf(query) -
      b.text.toLowerCase().indexOf(query);
  });
}

document.addEventListener("turbolinks:load", () => {
  // select2
  let query = {};
  $("[data-behavior='select2-nosearch']:not(.select2-hidden-accessible)").select2({
    language: {
      searching: function (params) {
        query = params;
        return 'Searching…';
      }
    },
    minimumResultsForSearch: Infinity,
    sorter: sorter,
  });
  $("[data-behavior='select2']:not(.select2-hidden-accessible)").select2({
    language: {
      searching: function (params) {
        query = params;
        return 'Searching…';
      }
    },
    sorter: sorter,
  });
  // select2 end

  // datepicker
  flatpickr("[data-behavior='flatpickr']:not(.flatpickr-input)", {
    altInput: true,
    altFormat: 'F j, Y',
    dateFormat: 'Y-m-d',
    allowInput: true,
    onOpen: function(selectedDates, dateStr, instance) {
      $(instance.altInput).prop('readonly', true);
    },
    onClose: function(selectedDates, dateStr, instance) {
      $(instance.altInput).prop('readonly', false);
      $(instance.altInput).blur();
    }
  });
});
